import { useApp } from '../Data/AppContext';

export const useIsHaveOurAssets = () => {
    const { stakedList, unstakedList, hasNtt } = useApp();

    return !!stakedList.length || !!unstakedList.length || hasNtt;
};
